import Vuex from 'vuex'
import Vue from 'vue'
import getters from './getter/getter'
import user from './modules/user'
import resources from './modules/resources'
import catalog from './modules/catalog'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    catalog,
    resources
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js